module.exports = __webpack_public_path__ + "img/ic_info_attestion.be1b35cc.svg";